// removed by extract-text-webpack-plugin
module.exports = {"texts":"src-components-Markdown----Markdown-module---texts---1ZZ0T","markdown":"src-components-Markdown----Markdown-module---markdown---1xD-F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Markdown/Markdown.module.scss
// module id = 1185
// module chunks = 168707334958949